module.exports = __webpack_public_path__ + "static/img/menage2.ffb67665.jpg";